import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from '@mui/material';

import { DocumentStatus } from '../../../../../../api/enumerations';
import { AcceptanceData } from '../../../../../../api/theHive/notices/types';
import {
  IconAttachFileMS,
  IconDescriptionMS,
} from '../../../../../../constants/icons';
import { formatDateAndTime } from '../../../../../../helpers';
import useGeneral from '../../../../../../hooks/useGeneral';
import {
  TableCellHeader,
  StyledCell,
  StyledRow,
  StatusCell,
  DownloadButton,
  ActionButton,
  StyledTooltip,
} from '../styles';
import { getDocumentStatusColor } from '../utils';

interface AcceptanceDocsTableProps {
  docList: AcceptanceData[];
}

export default function AcceptanceDocsTable({
  docList,
}: AcceptanceDocsTableProps): JSX.Element {
  const { handleDownloadFile } = useGeneral();

  const handleDownload = (
    url: string | null,
    filename: string | null
  ): void => {
    if (url && filename) {
      handleDownloadFile(url, filename);
    }
  };

  return (
    <Box my={5}>
      <Typography color="common.grey" fontSize={21} fontWeight={600} my={3}>
        Documentos para aceite
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCellHeader sx={{ padding: '20px 10px', width: '3%' }}>
                {IconAttachFileMS}
              </TableCellHeader>
              <TableCellHeader width="17%">documento</TableCellHeader>
              <TableCellHeader align="center" width="15%">
                status
              </TableCellHeader>
              <TableCellHeader align="center" width="20%">
                responsável
              </TableCellHeader>
              <TableCellHeader align="center" width="15%">
                data de aceite
              </TableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {docList.length === 0 && (
              <StyledRow>
                <StyledCell align="center" colSpan={5}>
                  Documentos pendentes de envio
                </StyledCell>
              </StyledRow>
            )}
            {docList.map((item) => (
              <StyledRow key={item.acceptance_document_id}>
                <StyledCell sx={{ padding: '20px 10px' }}>
                  <DownloadButton
                    disabled={!item.document_url}
                    onClick={() =>
                      handleDownload(
                        item.document_url,
                        item.document_original_filename
                      )
                    }
                  >
                    {IconDescriptionMS}
                  </DownloadButton>
                </StyledCell>
                <StyledCell>
                  <StyledTooltip
                    title={item.document_name || ''}
                    placement="top"
                  >
                    <Box>
                      <ActionButton
                        disabled={!item.document_url}
                        onClick={() =>
                          handleDownload(
                            item.document_url,
                            item.document_original_filename
                          )
                        }
                      >
                        <span>{item.document_name}</span>
                      </ActionButton>
                    </Box>
                  </StyledTooltip>
                </StyledCell>
                <StatusCell
                  align="center"
                  sx={{
                    color: getDocumentStatusColor(
                      item.accepted_at
                        ? DocumentStatus.APPROVED
                        : DocumentStatus.UNDER_ANALYSIS
                    ),
                  }}
                >
                  {item.accepted_at ? 'aceito' : 'pendente'}
                </StatusCell>
                <StyledCell align="center">
                  {item?.accepted_by?.name || ''}
                </StyledCell>
                <StyledCell align="center">
                  {formatDateAndTime(item.accepted_at || '')}
                </StyledCell>
              </StyledRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
